export function isIos() {
  return (
    !window.MSStream &&
    ([
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes('Mac') && 'ontouchend' in document))
  )
}

export const isMobileFirefox = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  return userAgent.includes('firefox') && userAgent.includes('mobile')
}
